/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2023-02-19 16:03:14
 * @LastEditors: 肖玲
 * @Description:
 * 客户档案
 */
import { getAllFields } from '@/api/field'
import { getlist } from '@/api/field'
import { detail as getClientDetail } from '@/api/client'
import { regionList as getRegionList } from '@/api/common'
import store from '@/store'

const customerArchivesRouter = [
  //档案页面，根据cls展示不同档案
  {
    path: '/masterDataSystem/client-page/:cls',
    name: 'clientPage',
    component: () =>
      import(
        /*webpackChunkName:"client" */
        // '@/views/masterDataSystem/ClientPage.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives/Page.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '终端列表',
    },
  },
  // 档案页面 历史数据
  {
    path: '/master-data-system/history-data/page/:meta_type/:json',
    name: 'masterDataSystemHistoryDataPage',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemHistoryDataPage" */
        // '@/views/masterDataSystem/historyData/Page.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives/HistoryData.vue'
      ),
  },
  // 档案页面 新增数据
  {
    path: '/masterDataSystem/client-add/:cls',
    name: 'clientAdd',
    component: () =>
      import(
        /*webpackChunkName:"clientEdit" */
        // '@/views/masterDataSystem/ClientAdd.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives/Add.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '添加终端',
      breadcrumb: [
        {
          title: '终端列表',
          name: 'clientPage',
        },
      ],
    },
    async beforeEnter(to, from, next) {
      await getlist(to.params.cls).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data.title_list) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientFields', res.data)
        }
      })
      await getAllFields(to.params.cls).then((res) => {
        if (0 === res.status) {
          // 去除关联档案控件--6.30版本关联档案控件
          // let target = res.data.filter((item) => item.type != 20)
          let target = res.data.filter(
            (item) =>
              item.type != 20 || (item.type == 20 && item.relation_type == 2),
          )
          for (let item of target) {
            if (item.type == 20) {
              item.client_id_20 = ''
              item.clientList = []
            }
          }
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of target) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientAllFields', target ? target : [])
        }
      })
      store.commit('setClientDetail', {
        clientRow: {
          name: '',
          regionIdList: [],
          address: '',
          client_level_id: [''],
          doctor_position_id: '',
          doctor_title_id: '',
          doctor_level_id: '',
        },
        clientCustomOptionsList: [],
        doctorGoodsList: [],
        doctorLevelList: [],
        doctorHospitalList: [],
      })
      // 获省市区
      await getRegionList('0', '0').then((res) => {
        if (0 === res.status) {
          store.commit('setRegionList', res.data.regionList)
          next()
        }
      })
    },
  },
  // 档案页面 编辑数据
  {
    path: '/masterDataSystem/client-edit/:id/:type/:third_platform_id',
    name: 'clientEdit',
    component: () =>
      import(
        /*webpackChunkName:"clientEdit" */
        // '@/views/masterDataSystem/ClientEdit.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives/Edit.vue'
      ),
    async beforeEnter(to, from, next) {
      await getAllFields(to.params.type).then((res) => {
        if (0 === res.status) {
          // 去除关联档案控件
          let target = res.data.filter(
            (item) =>
              item.type != 20 || (item.type == 20 && item.relation_type == 2),
          )
          for (let item of target) {
            if (item.type == 20) {
              item.client_id_20 = ''
              item.clientList = []
            }
          }
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of target) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }

          store.commit('setClientAllFields', target ? target : [])
        }
      })
      await getlist(to.params.type).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data.title_list) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientFields', res.data)
        }
      })
      getClientDetail(to.params.id).then((res) => {
        if (0 === res.status) {
          store.commit('setClientDetail', res.data)
          // 获省市区
          getRegionList('0', '0').then((res) => {
            if (0 === res.status) {
              store.commit('setRegionList', res.data.regionList)
              next()
            }
          })
        } else {
          store.commit('setClientDetail', {})
        }
      })
    },
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '终端编辑',
      breadcrumb: [
        {
          title: '终端列表',
          name: 'clientPage',
        },
      ],
    },
  },
  // 档案详情页面 from 来源 -1 普通
  // 1-多地址 2-拜访、协访详情,3-协议到期商业(天地恒一),4-商业回款(天地恒一),5-审批详情 ,6-审批中心
  //third_platform_id----工商局信息展示
  {
    path: '/masterDataSystem/client-detail/:id/:type/:from/:is_replace/:approval_id/:json/:third_platform_id',
    name: 'clientDetail',
    component: () =>
      import(
        /*webpackChunkName:"client" */
        // '@/views/masterDataSystem/ClientDetail.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives/Details.vue'
      ),
    async beforeEnter(to, from, next) {
      await getAllFields(to.params.type).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientAllFields', data)
        }
      })
      await getlist(to.params.type).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data.title_list) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientFields', res.data)
        }
      })
      next()
    },
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '终端详情',
      breadcrumb: [
        {
          title: '终端列表',
          name: 'clientPage',
        },
      ],
    },
  },

  // 终端详情页面 from 来源 -1 普通
  // 1-多地址 2-拜访、协访详情,3-协议到期商业(天地恒一),4-商业回款(天地恒一),5-审批详情 ,6-审批中心
  //通用服务商类型 universalId 只要传了 就是通用服务商类型 大于0 就是校验类型
  {
    path: '/masterDataSystem/client-detail/:id/:type/:from/:is_replace/:approval_id/:json/:universalId',
    name: 'universalClientDetail',
    component: () =>
      import(
        /*webpackChunkName:"client" */
        '@/views/master-data/master-data-maintain/customer-archives/archives/Details.vue'
        // '@/views/masterDataSystem/ClientDetail.vue'
      ),
    async beforeEnter(to, from, next) {
      await getAllFields(to.params.type).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientAllFields', data)
        }
      })
      await getlist(to.params.type).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data.title_list) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientFields', res.data)
        }
      })
      next()
    },
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '终端详情',
      breadcrumb: [
        {
          title: '终端列表',
          name: 'clientPage',
        },
      ],
    },
  },

  // 档案页面 主数据档案修改记录
  {
    path: '/masterDataSystem/master-redact-record/:id/:type/:third_platform_id',
    name: 'masterDataSystemMasterRedactRecord',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemMasterRedactRecord" */
        // '@/views/masterDataSystem/master-redact-record/MasterRedactRecord.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives/edit-record/Page.vue'
      ),
    async beforeEnter(to, from, next) {
      await getAllFields(to.params.type).then((res) => {
        if (0 === res.status) {
          // 去除关联档案控件
          let target = res.data.filter((item) => item.type != 20)
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of target) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientAllFields', target ? target : [])
        }
      })
      await getlist(to.params.type).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data.title_list) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientFields', res.data)
        }
      })
      getClientDetail(to.params.id).then((res) => {
        if (0 === res.status) {
          store.commit('setClientDetail', res.data)
          // 获省市区
          getRegionList('0', '0').then((res) => {
            if (0 === res.status) {
              store.commit('setRegionList', res.data.regionList)
              next()
            }
          })
        } else {
          store.commit('setClientDetail', {})
        }
      })
    },
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '档案修改记录',
      breadcrumb: [
        {
          title: '终端列表',
          name: 'masterDataSystemMasterRedactRecord',
        },
      ],
    },
  },

  // 档案页面 主数据档案修改记录 详情
  {
    path: '/masterDataSystem/master-redact-record/recordDetails/:id/:type/:priorId/:cls/:third_platform_id',
    name: 'masterDataSystemMasterRedactRecordDetails',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemMasterRedactRecord" */
        // '@/views/masterDataSystem/master-redact-record/recordDetails.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives/edit-record/Details.vue'
      ),
    async beforeEnter(to, from, next) {
      await getAllFields(to.params.type).then((res) => {
        if (0 === res.status) {
          // 去除关联档案控件
          let target = res.data.filter((item) => item.type != 20)
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of target) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientAllFields', target ? target : [])
        }
      })
      await getlist(to.params.type).then((res) => {
        if (0 === res.status) {
          let data = res.data
          if (
            store.state.accountInfo.quarterRow.is_admin == 1 ||
            store.state.accountInfo.quarterRow.is_attached_admin == 1
          ) {
            for (let item of data.title_list) {
              item.is_create = 1
              item.is_detail = 1
              item.is_edit = 1
              item.is_click = 1
              item.is_approval = 1
            }
          }
          store.commit('setClientFields', res.data)
        }
      })
      getClientDetail(to.params.priorId).then((res) => {
        if (0 === res.status) {
          store.commit('setClientDetail', res.data)
          // 获省市区
          getRegionList('0', '0').then((res) => {
            if (0 === res.status) {
              store.commit('setRegionList', res.data.regionList)
              next()
            }
          })
        } else {
          store.commit('setClientDetail', {})
        }
      })
    },
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '档案修改详情',
      breadcrumb: [
        {
          title: '主数据档案修改记录',
          name: 'clientPage',
        },
      ],
    },
  },

  // 档案主数据(快克)
  {
    path: '/masterDataSystem/client-master-data',
    name: 'quikeClientMasterData',
    component: () =>
      import(
        /*webpackChunkName:"client" */
        // '@/views/masterDataSystem/quike/clientMasterData.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives-data/Page.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '档案主数据',
    },
  },

  // 全部档案
  {
    path: '/masterDataSystem/all-client-page',
    name: 'AllclientPage',
    component: () =>
      import(
        /*webpackChunkName:"client" */
        // '@/views/masterDataSystem/AllClientPage.vue' // 待删除
        '@/views/master-data/master-data-maintain/customer-archives/archives-all/Page.vue'
      ),
    meta: {
      SecondaryMenu: '客户档案', //二级菜单
      title: '全部档案',
    },
  },
]

export default customerArchivesRouter
